import { useState } from "react";
import { Input } from "../../../Input";
import { Box } from "../../../box";
import { TbCoin } from "react-icons/tb";
import { Button } from "../../../../shared/components/button/button";

export function PixSimulationForm({
  onSimulate
}) {
  const [amount, setAmount] = useState("");
  const [messageVisible, setMessageVisible] = useState(false);

  const isDisabled = !amount || amount < 10;

  const handleAmountChange = (value) => {
    setAmount(value);
    setMessageVisible(value < 10);
  };

  return (
    <Box
      title={"Simular Pix Parcelado"}
      description={"Informe o valor e veja as opções de parcelamento com juros."}
    >
      <div className="flex gap-4">
        <div style={{ width: "50%" }}>
          <label className="font-semibold text-sm">Valor</label>
          <Input
            icon={<TbCoin size={18} />}
            type="currency"
            value={amount}
            onChange={handleAmountChange}
            placeholder="R$ 0,00"
          />
        </div>

        <div className="flex items-end mt-4">
          <Button
            onClick={() => onSimulate(amount)}
            size="sm"
            variant="primary"
            disabled={isDisabled}
          >
            Simular
          </Button>
        </div>
      </div>

      {messageVisible && (
        <p className="text-xs text-gray-500 mt-2">
          O valor mínimo para simulação é de R$ 10,00
        </p>
      )}
    </Box>
  );
}
